<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re42"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('teamDriverReview_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('teamDriverReview_batchOpenZy_button') && isCtms"
          @click="openZhaoYou()"
        >
          同步找油网
        </el-button>
        <el-button
          v-if="getLimit('teamDriverReview_batchOpenAmap_button')"
          @click="selectOpenAmap()"
        >
          开通高德账号
        </el-button>
        <el-button v-if="reportProvince ==8" @click="funcReport()">实际承运人上报</el-button>
        <el-button
          v-if="getLimit('teamDriverReview_batchReportDriver_button') && loginkTarget != 0&&!isAutomaticReport"
          @click="getSelectEvent()"
        >
          批量上报
        </el-button>
        <el-button
          v-if="getLimit('teamDriverReview_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :cell-class-name="cellClassName"
      class="mytable-style"
      @sort-change="sortList"
    >
      <!--      :checkbox-config="{labelField: '1', checkMethod: checCheckboxkMethod2}"-->
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          min-width="130"
          :formatter="formatterAuthStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="420"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="authMsg" title="驳回原因" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.authMsg" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="驾驶员姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange4"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClass"
          title="准驾类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleClass"
            placeholder="请输入准驾类型"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLicenseDueDate"
          title="驾驶证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="workLicense"
          title="道路运输从业资格证号"
          min-width="220"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.workLicense"
            placeholder="请输入道路运输从业资格证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="workLicenseDueDate"
          title="道路运输从业资格证号到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange3"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          min-width="420"
          title="注册时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isSendLoginkExt"
          :formatter="formatterIsSendLogink"
          title="是否上报"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendLoginkExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isSendLoginkOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="reportProvince ==8">
        <vxe-table-column
          field="isSendCyr"
          title="实际承运人是否上报省平台"
          :formatter="formatterOverload"
          min-width="200"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendCyr"
            clearable
            placeholder="请选择"
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column

        title="操作"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('teamDriverReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code,'detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamDriverReview_audit_button') && ((scope.row.authStatusExt != 3 && groupLevel == 0) || (scope.row.authStatusExt != 3&& groupLevel != 0))"
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code,'review')"
            >
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamDriverReview_openZy_button') && scope.row.authStatusExt == 3 && !scope.row.cardNo"
            class="item"
            effect="dark"
            content="同步找油网"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="openZhaoYou(scope.row)"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamDriverReview_openAmap_button') && scope.row.authStatusExt == 3 && !scope.row.amapTrid && groupLevel == 0"
            class="item"
            effect="dark"
            content="开通高德账号"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="openAmap(scope.row)"
            >
              <i class="el-icon-map-location" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamDriverReview_report_button') && scope.row.authStatusExt === 3 && scope.row.driverType != 1 && loginkTarget != 0 && !( scope.row.isSendLoginkExt == 1 && loginkTarget == 7)&&!(isAutomaticReport&&scope.row.isSendLoginkExt != 2)"
            class="item"
            effect="dark"
            content="上报"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="reportLogink(scope.row.partyCode)"
            >
              <i class="el-icon-top-right" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamDriverReview_applyDis_button') && showApplyDisBtn(scope.row)"
            class="item"
            effect="dark"
            content="申请DIS"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcApply(scope.row.partyCode)"
            >
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
          <template v-if="scope.row.gmiId">
            <!-- <el-tooltip v-if="teamDriverReview_recoveryBackMoney_button" class="item" effect="dark" content="万金油余额回收" placement="top">
              <vxe-button type="text" @click="funcRecoveryBackMoney(scope.row)">
                <i class="el-icon-s-release" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip v-if="teamDriverReview_cancelRecharge_button" class="item" effect="dark" content="万金油待领取撤销" placement="top">
              <vxe-button type="text" @click="funcCancelRecharge(scope.row)">
                <i class="el-icon-document-delete" />
              </vxe-button>
            </el-tooltip> -->
            <el-tooltip v-if="teamDriverReview_oilOrderBackMoney_button" class="item" effect="dark" content="万金油余额" placement="top">
              <vxe-button type="text" @click="funOilOrderBackMoney(scope.row)">
                <i class="el-icon-s-order" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 详情 -->
    <vxe-modal
      v-model="driverFlag"
      :title="modelTtile"
      width="1200"
      height="80%"
      resize
    >
      <driverDetail
        ref="detailRef"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>
    <!-- 报文  -->
    <vxe-modal
      v-model="datagramFlag"
      title="报文详情"
      width="800"
      height="600"
      resize
    >
      <datagramDetail
        ref="datagramRef"
        :parent-data="parentData"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <oilOrderBackMoney ref="oilOrderBackMoneyRef" />
    <oilRecoveryBackMoney ref="oilRecoveryBackMoneyRef" />
    <oilCancelRecharge ref="oilCancelRechargeRef" />
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import { maYiBlockChain } from "@/api/shipment";
  import driverDetail from "./components/driverDetail.vue";
  import datagramDetail from "./components/datagramDetail.vue";
  import { updateAuthStatus, getDriverTeamList, openZhaoYou ,reportDriverInfo, openAmap} from "@/api/driver";
  import { getRole } from '@/utils/getRole';
  import oilOrderBackMoney from '@/views/basicInfo/driver/driverManage/components/oilOrderBackMoney'
  import oilRecoveryBackMoney from "@/views/basicInfo/driver/driverManage/components/oilRecoveryBackMoney"
  import oilCancelRecharge from "@/views/basicInfo/driver/driverManage/components/oilCancelRecharge"
  export default {
    name: "CarrierReview",
    components: {
      driverDetail,
      datagramDetail,
      oilOrderBackMoney,
      oilRecoveryBackMoney,
      oilCancelRecharge
    },
    data() {
      return {
        exportObj:{
          exportUrl:"/ntocc-basic-api/driver/exportTeamDriverAuth",//导出接口
          name:'车队实际承运人'
        },
        isCtms:true,//默认显示  同城系统隐藏
        modelTtile:'详情',
        parentData: {
          model:'detail',
          isDetail: true,
          areaOptions: this.$store.state.components.areaOptions,
          receiverUserCodeOptions: [],
          typeOptions: [],
          bankOptions: []
        },
        formatterOverload({ cellValue }) {
          switch (cellValue) {
            case 1:
              return "是";
            case 0:
              return "否";
            default:
              return "";
          }
        },
        exportableQuantity: localStorage.getItem('exportableQuantity'),
        exportableUrl:'ntocc-basic-api/driver/exportTeamDriverAuth',
        loginkTarget: 0,
        loading: false,
        tableData: [],
        driverFlag: false,
        datagramFlag: false,
        listQuery: {
          driverLicenseDueDateRange: "",
          driverLicenseFromDateRange: "",
          driverLicenseDueDateRange3:'',
          driverLicenseDueDateRange4:'',
          gmtCreatedRange: "",
          authTimeRange: "",
          branchCodeExt: "",
          authStatus: "",
          authStatusExt: "",
          name: "",
          phone: "",
          driverType: "2",
          identificationNumber: "",
          balanceStart: "",
          balanceEnd: "",
          gmtCreatedEnd: "",
          gmtCreatedStart: "",
          driverLicenseDueDateStart: "",
          driverLicenseDueDateEnd: "",
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        },
        reportProvince:'',
        sumObject: {
          balance: 0
        },
        // 审核状态
        authStatusOptions: [
          {
            label: "未审核",
            value: 0
          },
          // {
          //   label: "审核中",
          //   value: 1
          // },
          {
            label: "审核驳回",
            value: 2
          },
          {
            label: "审核通过",
            value: 3
          }
        ],
        //
        isSendLoginkOptions: [
          {
            label: "未上报",
            value: 0
          },
          {
            label: "已上报",
            value: 1
          },
          {
            label: "上报失败",
            value: 2
          }
        ],
        teamDriverReview_recoveryBackMoney_button:false,
        teamDriverReview_cancelRecharge_button:false,
        teamDriverReview_oilOrderBackMoney_button: false,
      };
    },
    computed:{
      ...mapState({
        isAutomaticReport: (state) => state.user.party.isAutomaticReport,
      }),
      model(){
        return this.parentData.model
      }
    },
    watch: {
      $route(to, from) {
        const v = to.query.todo;
        if (v) {
          this.listQuery.authStatusExt = 0;
        } else {
          this.listQuery.authStatusExt = "";
        }
        this.findList();
      },
     model(val) {
         this.modelTtile = val === 'review'? '审核':'详情'
      }
    },

    created() {
      this.teamDriverReview_recoveryBackMoney_button = this.getLimit('teamDriverReview_recoveryBackMoney_button')
      this.teamDriverReview_cancelRecharge_button = this.getLimit('teamDriverReview_cancelRecharge_button')
      this.teamDriverReview_oilOrderBackMoney_button = this.getLimit('teamDriverReview_oilOrderBackMoney_button')
      const v = this.$route.query.todo;
      if (v) {
        this.listQuery.authStatusExt = 0;
      }
      this.findList();
      this.isCtmsShow = getRole();//获取登录用户登录的是否是同城系统
      let dataBranch = JSON.parse(localStorage.getItem('dataBranch'));
      this.platformDid = dataBranch.platformDid;
      this.reportProvince= dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue;
      this.loginkTarget =
        dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue:0;
      this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain ? dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1 : false;
      this.groupLevel = JSON.parse(localStorage.getItem('dataBranch')).level;
      this.listQuery.branchCodeExt = JSON.parse(localStorage.getItem('dataBranch')).code;
    },
    mounted() {
    },
    methods: {
      showApplyDisBtn(row) {
        if (!this.openMaYiBlockChain || this.isCtmsShow) {
          return false;
        }
        let hasDid = !(typeof this.platformDid == "undefined" || this.platformDid == '');
        return hasDid && row.authStatusExt == 3 && (row.szwlDid == null || row.szwlDid == '');
      },
      // 类型筛选
      formatterDriverType({ cellValue }) {
        let item = this.driverTypeOptions.find(item => item.value === cellValue);
        return item ? item.label : "";
      },
      formatterIsSendLogink({ cellValue }) {
        let item = this.isSendLoginkOptions.find(
          item => item.value === cellValue
        );
        return item ? item.label : "";
      },
      findList() {
        this.loading = true;
        return new Promise(resolve => {
          getDriverTeamList(this.listQuery).then(response => {
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            this.sumObject = response.data.sumObject;
            this.loading = false;
            resolve();
          });
        });
      },
      // 详情
      funcEdit(code,prefix) {
        this.driverFlag = true;
        this.$refs.detailRef.getDriver(code);
        this.$set(this.parentData,'model',prefix)
      },
      fatherMethods() {
        this.driverFlag = false;
        this.findList();
      },
      // 报文详情
      funcSendDataGram(code) {
        this.datagramFlag = true;
        this.$refs.datagramRef.getDriver(code);
      },
      //同步找油网
      openZhaoYou(row) {
        const selectRecords = row?[row]:this.$refs.xTable.getSelectRecords();
        if (!selectRecords || selectRecords.length === 0) {
          return this.$message({ message: "请选择实际承运人", type: "warning" });
        } else if (selectRecords.length > 100) {
          return this.$message({ message: "批量处理最多100条数据", type: "warning" });
        } else {
          let codes = []
          for(let item of selectRecords){
            if(item.authStatusExt!=3){
              return this.$message.warning("请选择审核通过的实际承运人")
            }
            if(item.cardNo){
              return this.$message.warning("实际承运人已同步")
            }
            codes.push(item.partyCode)
          }
          codes = codes.join(",");
          this.$confirm("确认同步找油网？")
          .then(_ => {
            const rLoading = this.openLoading();
            openZhaoYou({ partyCode: codes }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
        }
      },
      //开通高德账号
      openAmap(row) {
        this.$confirm("确认开通高德账号？")
          .then(_ => {
            openAmap({ partyCodes: row.partyCode }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 翻译审核状态
      formatterAuthStatus({ cellValue }) {
        const item = this.authStatusOptions.find(
          item => item.value === cellValue
        );
        return item ? item.label : "";
      },
      // 上报
      reportLogink(c) {
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const codes = c;
          const rLoading = this.openLoading();
          reportDriverInfo({codes}).then(response => {
            this.$message({message: response.msg, type: "success"});
            this.findList();
            rLoading.close();
          });
        });
      },
      // 申请DIS
      async funcApply(codes) {
        let response = await maYiBlockChain(codes)
        this.$message({message: response.msg, type: "success"});
        this.findList();
      },
      // 实际承运人上报
    funcReport(){
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
        if (isTeamArray.length) {
          this.$message({ message: "请勿选择车队", type: "warning" });
          return false;
        }
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          updateAuthStatus({ driverCodes: codes, sendType: 3 }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          }).finally(()=>{
            this.findList();
          });
        });
      }
    },
      getSelectEvent() {
        const selectRecords = this.$refs.xTable.getSelectRecords();
        if (!selectRecords || selectRecords.length === 0) {
          this.$message({message: "请选择实际承运人", type: "warning"});
        } else {
          const codes = selectRecords.map(item => item.partyCode).join(",");
          this.$confirm("确认上报监管平台吗？").then(_ => {
            const rLoading = this.openLoading();
            reportDriverInfo({codes}).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: "success"});
            }).finally(() => {
              this.findList();
            });
          });
        }
      },
      selectOpenAmap() {
        const selectRecords = this.$refs.xTable.getSelectRecords();
        if (!selectRecords || selectRecords.length === 0) {
          this.$message({ message: "请选择实际承运人", type: "warning" });
        } else if (selectRecords.length > 20) {
          this.$message({ message: "批量处理最多20条数据", type: "warning" });
        } else {
          /*        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
                  if (isTeamArray.length) {
                    this.$message({ message: "请勿选择车队", type: "warning" });
                    return false;
                  }*/
          const codes = selectRecords.map(item => item.partyCode).join(",");
          this.$confirm("确认开通高德账号？").then(_ => {
            const rLoading = this.openLoading();
            openAmap({ partyCodes: codes }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
              rLoading.close();
            });
          });
        }
      },
			cellClassName({ row, rowIndex, column, columnIndex }) {
			  const overDueType = row.overDueType||[];
			  //驾驶证
			  if (column.property === "driverLicenseDueDate") {
			    if (overDueType.indexOf('driver')>-1) {
			      return "col-red";
			    }
			  }
			  //形驶证
			  if (column.property === "vehicleLicenseDueDate") {
			    if (overDueType.indexOf('vehicle')>-1) {
			      return "col-red";
			    }
			  }
			  //从业资格证
			  if (column.property === "workLicenseDueDate") {
			    if (overDueType.indexOf('work')>-1) {
			      return "col-red";
			    }
			  }
			  //从业资格证
			  if (column.property === "roadTransportCertificateDate") {
			    if (overDueType.indexOf('road')>-1) {
			      return "col-red";
			    }
			  }
			  //身份证
			  if (column.property === "idCardDueDate") {
			    if (overDueType.indexOf('idCard')>-1) {
			      return "col-red";
			    }
			  }
			},
      // 设置底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (column.property === "balance") {
              return this.$XEUtils.sum(data, column.property);
            }
            return "-";
          })
        ];
      },
      checCheckboxkMethod2 ({ row }) {
        return  row.isSendLoginkExt != 1
      },
      // 万金油余额回收
      funcRecoveryBackMoney(row) {
        this.$refs.oilRecoveryBackMoneyRef.show(row)
      },
      // 万金油待领取撤销
      funcCancelRecharge(row) {
        this.$refs.oilCancelRechargeRef.show(row)
      },
      // 万金油余额
      funOilOrderBackMoney(row) {
        this.$refs.oilOrderBackMoneyRef.show(row)
      }
    }
  };
</script>
<style scoped>
	.mytable-style .vxe-body--column.col-red {
	  background-color: red;
	  color: #fff;
	}
